export var defaultProps = {
    className: '',
    placeholder: '',
    dropdownClassName: '',
    disabled: false,
    filterOption: function () { return true; },
    onChange: function (value, e) { },
    onSearch: function (value) { },
    onSelect: function (value, option) { },
    onFocus: function () { },
    onBlur: function () { },
};
export var defaultOptionList = {
    disabled: false,
};
